// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-content {\n  max-width: 768px;\n}\n\nion-toolbar {\n  max-width: 768px;\n  --background: rgba(255, 255, 255, .62);\n}\n\n.sc-ion-searchbar-ios-h {\n  --border-radius: 18px;\n  --box-shadow: none;\n  padding: 8px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
